import { Box } from '../Box';
import { Icon } from '../Icon';
import { Typography } from '../Typography';

/**
 * Свойства компонента {@link ToTopButton}
 */
interface ToTopButtonProps {
  /**
   * Функция, вызываемая при клике на кнопку для прокрутки к началу страницы.
   */
  scrollToStart: () => void;
}

/**
 * Кнопка "Наверх", фиксированно расположенная внизу экрана.
 *
 * @public
 * @param scrollToStart - Функция, вызываемая при клике на кнопку для прокрутки к началу страницы.
 * @returns Компонент ToTopButton.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link ToTopButtonProps}
 */
export const ToTopButton = ({ scrollToStart }: ToTopButtonProps) => {
  return (
    <Box
      position="fixed"
      display="flex"
      alignItems="center"
      zIndex={1000}
      bottom={20}
      bgcolor="bg.light.primary"
      radius="m"
      boxShadow="0px 2px 8px 0px rgba(0,26,77,0.10), 0px 6px 28px 0px rgba(0,26,77,0.12) !important"
      onClick={scrollToStart}
      py="8"
      px="16"
      cursor="pointer"
    >
      <Icon name="arrow_up_outline" size="20" color="original.brand.primary" />

      <Typography variant="subtitle1" color="original.brand.primary">
        Наверх
      </Typography>
    </Box>
  );
};
